import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=a0962432&scoped=true&"
import script from "./Invoice.vue?vue&type=script&lang=ts&"
export * from "./Invoice.vue?vue&type=script&lang=ts&"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=a0962432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0962432",
  null
  
)

export default component.exports